import "babel-polyfill";
import "whatwg-fetch";
import 'promise-polyfill/src/polyfill.js';
// import '../main.mjs';
import * as Helper from '../weave/helpers.mjs';
import {FurnitureIndex} from './classes/furniture_index.js';

let form = document.getElementById("searchForm");
new FurnitureIndex(form);